<p>advertisement-video works!</p>
<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
    <main class="page-content">
        <div class="bgColor">
            <div class="container">
                <div class="row" style="height: 4em;">
                    <div class="col-md-6">
                        <p class="appTitle">Ad Images</p>
                    </div>
                    <div class="col-md-6">
                        <p class="adminName">{{ adminName }} <img width="30px" height="30px" style="margin-left:0.5em;"
                                [src]="adminImage" class="rounded-circle"></p>
                    </div>
                </div>

                <div class="row my-4">
                    <div class="col">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-3 searchCol">
                                    <div class="form-inline">
                                        <input class="form-control form-control-sm ml-3 w-75" type="text"
                                            (change)="onChangeEvent($event)" placeholder="Country" aria-label="Search"
                                            [(ngModel)]="searchval">
                                        <i class="fa fa-search searchIcon" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="col-md-3 searchCol">
                                    <button type="button" class="btn btn-primary" (click)="reset()">Reset</button>
                                </div>
                                <div class="col-md-3 searchCol">
                                    <button type="button" class="btn btn-primary addCourseBtn" (click)="openAdd()"><i
                                            class="fa fa-plus" aria-hidden="true"></i> Add Video</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tableView" *ngIf="showData">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>S.NO</th>
                                    <th> Name</th>
                                    <th>Video URL</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let video of allVideos; let i = index;">
                                    <td>{{ i+1 }}</td>
                                    <td>Neet</td>
                                    <td><img width="30px" height="30px" [src]="video.image" class="rounded-circle"> {{
                                        video.url }}</td>
                                    <td style="text-align: center;">
                                        <i class="fa fa-trash-o iconEdit" aria-hidden="true"
                                            (click)="deleteVideo(video.id)"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="noData" *ngIf="showNoForeign">
                    <h2>Currenly No Data Available!</h2>
                </div>


            </div>

            <div class="backdrop" [ngStyle]="{'display':display}"></div>
            <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header" *ngIf="showAdd">
                            Add Video
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <!-- <div>
                            <label>URL</label>
                            <br>
                            <input  [(ngModel)]="advertisementurl">

                        </div> -->

                        <div class="modal-header" *ngIf="showEdit">
                            Edit Images
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="dltmodal-content animate modal-body dltBl">
                            <form [formGroup]="imageForm">
                                <div>
                                    <label>URL</label>
                                    <br>
                                    <input formControlName="url" [(ngModel)]="advertisementurl" class="url">
        
                                </div>
                                <br>
                                <label class="uploadImage">Upload Image
                                    <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                                    <input type="file" formControlName="imageVal" (change)="handleFileInput($event)"
                                        multiple="" hidden>
                                </label>
                                <img class="multipleImg" width="80px" height="80px" *ngFor="let img of images"
                                    [src]="img">
                                <div class="error-messages">
                                    <div *ngFor="let error of error_messages.imageVal">
                                        <div class="error-message"
                                            *ngIf="imageForm.get('imageVal').hasError(error.type) && (imageForm.get('imageVal').dirty || imageForm.get('imageVal').touched)">
                                            {{ error.message }}
                                        </div>
                                    </div>
                                </div>

                                <!-- <label class="uploadImage">Upload Image
                                    <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                                    <input type="file" formControlName="imageVal" (change)="handleFileInput($event.target.files)"
                                        hidden>
                                </label>
                                <img width="80px" height="80px" *ngIf="imageUrl" [src]="imageUrl"> -->

                                <!-- <label style="margin-top:1em;">Select Country</label>
                                <select class="form-control" [(ngModel)]="countryid" formControlName="countryName">
                                    <option *ngFor="let country of countryVal;let x = index" [ngValue]="country.id">{{
                                        country.country }}</option>
                                </select> -->

                                <div class="error-messages">
                                    <div *ngFor="let error of error_messages.countryName">
                                        <div class="error-message"
                                            *ngIf="imageForm.get('countryName').hasError(error.type) && (imageForm.get('countryName').dirty || imageForm.get('countryName').touched)">
                                            {{ error.message }}
                                        </div>
                                    </div>
                                </div>

                                <label style="margin-top:1em;">Select College Type</label>
                                <select class="form-control" [(ngModel)]="imgTypeId" formControlName="imageTypeVal">
                                    <option *ngFor="let image of imgType;let x = index" [ngValue]="image.id">{{
                                        image.type
                                        }}</option>
                                </select>
                                <div class="error-messages">
                                    <div *ngFor="let error of error_messages.imageTypeVal">
                                        <div class="error-message"
                                            *ngIf="imageForm.get('imageTypeVal').hasError(error.type) && (imageForm.get('imageTypeVal').dirty || imageForm.get('imageTypeVal').touched)">
                                            {{ error.message }}
                                        </div>
                                    </div>
                                </div>

                                <div class="addBtn" *ngIf="showAdd">
                                    <button class="commonBtn mt-2" (click)="addvideos()">Add
                                        Videos</button>
                                </div>

                                <div class="addBtn" *ngIf="showEdit">
                                    <button class="commonBtn mt-2" (click)="imgUpdate()">Update</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="backdrop" [ngStyle]="{'display':displayDelete}"></div>
            <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayDelete}">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="dltmodal-content animate modal-body dltBl mb-3" style="text-align:center;">
                            <p>Do you want to delete College ?</p>
                            <button type="submit" class="btn btn-success" (click)="delete()"
                                style="width: 20%;">Yes</button>
                            <button type="submit" class="btn btn-danger" (click)="onCloseHandled()"
                                style="width: 20%;margin-left: 0.3em;">No</button><br><br>
                            <p class="error" *ngIf="showErr">{{ deleteErr }}</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </main>
</div>